import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Plan } from "../../domain/models/plan";
import { PlansRepository } from "../../repositories";
import { Observable } from "rxjs";
import { PlanRequest } from "../../domain/requests/plans/plan.request";

@Injectable({ providedIn: 'root' })
export class EditPlanUsecase implements UseCase<PlanRequest, string> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: PlanRequest): Observable<string> {
    return this.planRepository.editPlan(params);
  }
}
